import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";

interface UseCreatePrivateCompanyLeadContractFeeProps {
  privateCompanyLeadId?: string
  onSuccess: () => void
  onError: () => void
}

const useCreatePrivateCompanyLeadContractFee = ({ privateCompanyLeadId, onSuccess, onError }: UseCreatePrivateCompanyLeadContractFeeProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation({
    mutationKey: ['createPrivateCompanyLeadContractFee'],
    mutationFn: async (data: { label: string, value: string }) => {
      const private_company_lead = {
        contract_attributes: {
          contract_fees_attributes: [
            {
              fee_template_id: data.value,
            }
          ]
        }
      }

      await privateAxios.putForm(`/funnel/private_company_leads/${privateCompanyLeadId}`, {
        private_company_lead
      })
    },
    onSuccess,
    onError,
  })
}

export default useCreatePrivateCompanyLeadContractFee